module.exports = __webpack_public_path__ + "media/images/icon-caution-549c0875060711e3825ebff9d1e795b9.svg";